import { networkStatus } from "./network_status"
import { t } from "../api_helper"

// Check if error is an offline error
export function isOfflineError(e) {
  return e?.isOffline === true
}

// Show offline placeholder in a target element, auto-retry when back online
export function showOfflinePlaceholder(target, retryFn) {
  if (!target) return

  target.innerHTML = `
    <div class="flex flex-col items-center justify-center py-16 px-6">
      <div class="text-3xl mb-3">📡</div>
      <div class="text-sm font-medium mb-1">${t("errors.offline_title")}</div>
      <div class="text-xs mb-4" style="color: rgb(148,163,184);">${t("errors.offline_hint")}</div>
    </div>`

  // Auto-retry when back online
  const unsub = networkStatus.onChange((online) => {
    if (online) {
      unsub()
      retryFn()
    }
  })
}

// Alert user that action requires connection
export function alertOffline() {
  alert(t("errors.offline_action"))
}
